import React from 'react';
import img1 from '../images/img1.jpg'
import Reveal from './atoms/reveal';

function About() {
    return (
        <section id="about" className="py-32">
            <div className="flex items-center justify-center py-5">
                <div className="container relative z-30">
                    <Reveal className="section-heading text-center">
                        <h2 className="text-4xl text-center font-semibold pb-6">About me</h2>
                    </Reveal>
                    <div className="grid gap-6 grid-flow-row-dense grid-cols-5 justify-center xl:px-40 px-10">
                        <Reveal variant="left" className="col-span-6 md:col-span-2 sm:col-span-5">
                            <img src={img1} className="w-full max-w-full h-auto rounded" alt="" />
                        </Reveal>
                        <Reveal variant="right" delay={150} className="col-span-6 md:col-span-3 sm:col-span-5">
                            <p>
                                神戸出身のエンジニア。大学で知能情報学を学んだのち現在は、シナジーマーケティング株式会社でエンジニアをしています。
                                主に集客、顧客情報の統合、メッセージング、分析まで、CRMのあらゆる活動を支えるシステム "Synergy!" のバックエンドを開発しています。
                                趣味はプログラミングや技術系のイベントに参加することです。
                                プログラミングは普段KotlinとJava,Pythonなどをよく書いています。技術面では、最近はK8sやAWSなどを勉強しています。
                            </p>
                        </Reveal>
                    </div>
                </div>
            </div>
        </section >
    );
}

export default About;
